import React from 'react';

import { ButtonPrimary } from '../';
import ButtonBack from '../ButtonBack';
import TitlePage from '../TitlePage';
import { LoadingIcon } from '../LoadingIcon';
import { RootContent, DivHeader, ContentContainer, Row } from './styles';
import { Spacer } from '../index';

export function PrivatePageStructure({
  children,
  loading,
  title,
  disableButtons = false,
  btn1Title = 'DESCARTAR',
  btn2Title = 'SALVAR ALTERAÇÕES',
  btn1Action,
  btn2Action,
  btn1Loading = false,
  btn2Loading = false,
  btn1Disable = false,
  btn2Disable = false,
  enableBackButton = false,
  backButtonDestPage = '/',
  backButtonCb,
  disableHeaderSpacer = false,
}) {
  return (
    <RootContent loading={loading}>
      {enableBackButton && (
        <ButtonBack previousPage={backButtonDestPage} cb={backButtonCb} />
      )}
      <DivHeader>
        {typeof title === 'string' ? <TitlePage label={title} /> : title}
        {!disableButtons && (
          <Row>
            <ButtonPrimary.Normal
              label={btn1Title}
              type="outline"
              onClick={btn1Action}
              isLoading={btn1Loading}
              disable={btn1Disable}
            />
            <ButtonPrimary.Normal
              label={btn2Title}
              onClick={btn2Action}
              isLoading={btn2Loading}
              disable={btn2Disable}
            />
          </Row>
        )}
      </DivHeader>
      {!disableHeaderSpacer && <Spacer.vertical size={20} />}
      <ContentContainer>
        {loading ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              width: '100%',
            }}
          >
            <LoadingIcon />
          </div>
        ) : (
          <>{children}</>
        )}
      </ContentContainer>
    </RootContent>
  );
}
